"use strict";

import angular from "angular";

import template from "./group-companies-sidenav.component.html";
import "./themes/group-companies-sidenav.component.scss";

import { Events } from "../../../presentation/services/Events/Events";
import { NormalizeString } from "../../../utils/normalize-string/NormalizeString";

/**
 * Id do `md-sidenav`. Exportado porque quem abre o painel é o header (`header-top-nav`), e o
 * `$mdSidenav` endereça pelo id — string repetida nos dois lados é o que faz o clique não abrir
 * nada quando um deles muda.
 */
export const GROUP_COMPANIES_SIDENAV_ID = "sidenavGroupCompanies";

/**
 * Painel lateral com as empresas-membro do grupo aberto no momento.
 *
 * Dentro de um grupo o cabeçalho mostra só o nome dele, e atravessar para uma das empresas exigia
 * sair do grupo, voltar para a carteira e procurar a empresa na lista. O painel é esse atalho: a
 * lista que o grupo já carregou (`$rootScope.company.companies`, resolvida em `group.routes.js`),
 * com o salto direto para o dashboard de cada empresa.
 *
 * O dashboard abre em NOVA GUIA de propósito: quem clica está lendo o consolidado do grupo e quer
 * comparar com uma empresa, não trocar de contexto — navegar na mesma aba descartaria a análise
 * (e, no caso do grupo, a customização aberta).
 *
 * Só o dashboard: o diagnóstico da empresa continua no painel de grupo da Central Consultiva (v2),
 * onde ele é o assunto. Aqui o atalho existe para descer do consolidado para o dado de uma empresa.
 */
export class GroupCompaniesSidenavComponent {
    constructor($scope, $state, $mdSidenav, $rootScope) {
        this.$scope = $scope;
        this.$state = $state;
        this.$mdSideNav = $mdSidenav;
        this.$rootScope = $rootScope;

        this.componentId = GROUP_COMPANIES_SIDENAV_ID;
        this.Events = new Events();
    }

    /** O grupo aberto. `group.routes.js` publica o resolvido em `$rootScope.company`. */
    group() {
        const company = this.$rootScope.company;
        return company?.isGroup ? company : {};
    }

    companies() {
        return this.group().companies || [];
    }

    formatDocument(document) {
        return NormalizeString.formatDocument(document);
    }

    getAccountingId() {
        return (
            this.$state.params.accIdReference ||
            this.$state.params.accountingId
        );
    }

    onClose() {
        this.$mdSideNav(this.componentId).close();
    }

    onOpenDashboard(company) {
        if (!company?._id) return;
        this.Events.send("grupo.header.empresas.dashboard");
        window.open(
            this.$state.href("nucont.accounting.company", {
                id: company._id,
                accountingId: this.getAccountingId()
            }),
            "_blank"
        );
    }
}

GroupCompaniesSidenavComponent.$inject = [
    "$scope",
    "$state",
    "$mdSidenav",
    "$rootScope"
];

const name = "groupCompaniesSidenavComponent";
const def = {
    controller: GroupCompaniesSidenavComponent,
    bindings: {},
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
